<template>
  <!--コンバートエラー modal-->
  <i-modal
    v-model="modal"
    :title="title"
    :mask-closable="false"
    @on-visible-change="onVisibleChange"
    class="modal-convert_error"
  >
    <div v-if="info.bName">
      <div v-if="errorList.length > 0" class="clipboard">
        <i-button
          type="primary"
          size="small"
          v-clipboard:copy="clipboard"
          v-clipboard:success="onClipBoardCopy"
          v-clipboard:error="onClipBoardError"
          icon="md-clipboard"
        >
          クリップボードへコピー
        </i-button>
      </div>
      <div class="b_name">{{ info.bName }}</div>
      <div class="shop_name">
        {{ info.shopName }}
        <i-tag color="magenta" style="margin-left: 8px;">{{ errorSiteName }}</i-tag>
      </div>
      <div class="list-convert_error">
        <i-cell-group>
          <i-cell
            v-for="(item, itemIdx) in errorList"
            :key="itemIdx"
            :title="item"
            style="color: #ed4014;"
          />
        </i-cell-group>
      </div>
      <div class="button-area">
        <i-button type="primary" @click="onClickBukkenEdit">物件編集</i-button>
      </div>
    </div>
    <div v-else>
      <p>
        通信エラーによりコンバートステータス変更処理が実行できませんでした。
      </p>
    </div>
    <div slot="footer">
      <i-button type="primary" @click="onClickClose">閉じる</i-button>
    </div>
  </i-modal>
</template>

<script>
import Vue from 'vue'
// @docs https://github.com/Inndy/vue-clipboard2
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import { Modal, Button, Tag, CellGroup, Cell, Message } from 'view-design'
Vue.prototype.$Message = Message
import { isResidence, isInvestment } from '@/util/m_b_type.js'
const EDITOR_URL = `${process.env.VUE_APP_EDITOR_DOMAIN}/edit`
export default {
  components: {
    'i-modal': Modal,
    'i-button': Button,
    'i-tag': Tag,
    'i-cell-group': CellGroup,
    'i-cell': Cell,
  },
  data() {
    return {
      error: {},
    }
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalConvertError/getModal']
      },
      set(val) {
        this.$store.commit('ModalConvertError/setModal', val)
      },
    },
    title() {
      return this.$store.getters['ModalConvertError/getTitle']
    },
    info() {
      return this.$store.getters['ModalConvertError/getBukkenInfo']
    },
    errorList() {
      return this.$store.getters['ModalConvertError/getErrorList']
    },
    errorSiteName() {
      return this.$store.getters['ModalConvertError/getErrorSiteName']
    },
    property() {
      return this.$store.getters['Property/getProperty']
    },
    clipboard: function() {
      let problem = ''
      if (this.errorList.length > 0) {
        problem = this.errorList.join('\n')
      }
      return `${this.info.id}
${this.info.bName}
${this.info.shopName}
${this.errorSiteName}
${problem}`
    },
  },
  methods: {
    // モーダル 起動時 / 終了時の処理
    onVisibleChange(isOpen) {
      // 起動時にエラー内容を取得する
      if (isOpen) {
        this.error = this.$store.getters['ModalConvertError/getCurrentError']
      } else {
        // 終了時にエラー内容を削除
        this.$store.commit('ModalConvertError/reset')
      }
    },
    // モーダル 閉じるボタン処理
    onClickClose() {
      this.modal = false
    },
    // 物件編集ボタン クリック処理
    onClickBukkenEdit() {
      const id = this.info.id
      let type = ''
      const data = _.find(this.property, function(item) {
        return item.id === id
      })
      if (isResidence(data.m_b_type_id)) type = 'residence'
      if (isInvestment(data.m_b_type_id)) type = 'investment'
      window.open(`${EDITOR_URL}/${type}/${id}/regulars`, '_blank')
    },
    // クリップボード コピー成功処理
    onClipBoardCopy() {
      this.$Message.info('クリップボードにコピーしました。')
    },
    // クリップボード コピー失敗処理
    onClipBoardError() {
      this.$Message.error('コピーに失敗しました。')
    },
  },
}
</script>

<style lang="scss">
.modal-convert_error {
  .ivu-cell {
    white-space: normal;
  }
  .clipboard {
    text-align: right;
  }
  .b_name {
    font-size: 14px;
    font-weight: bold;
  }
  .shop_name {
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 8px;
    padding-bottom: 4px;
  }
  .list-convert_error {
    max-height: 300px;
    overflow: scroll;
  }
  .button-area {
    margin-top: 8px;
    text-align: right;
  }
}
</style>
